import type { ReadonlyURLSearchParams } from "next/navigation";

// Field names of the lead-attribution contract shared by the website, the forms, the automation
// and the CRM. Booking links carry them as plain query parameters. Cal only keeps utm_* (in
// Tracking, which webhook payloads do not include) and silently drops any other unknown
// parameter, so they are copied into booking metadata, which webhooks do include.
export const ATTRIBUTION_QUERY_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_ad_content",
  "gclid",
  "fbclid",
  "msclkid",
  "li_fat_id",
  "referrer_domain",
  "landing_page",
  "conversion_page",
  "cta_location",
  "ft_source",
  "ft_medium",
  "ft_campaign",
  "ft_referrer_domain",
  "ft_landing_page",
  "ph_id",
  "ph_session_id",
] as const;

// Values come straight from the URL, so cap them before they are stored and forwarded
const MAX_VALUE_LENGTH = 500;

export function getAttributionMetadata(searchParams: ReadonlyURLSearchParams | null): Record<string, string> {
  if (!searchParams) return {};

  const metadata: Record<string, string> = {};
  for (const name of ATTRIBUTION_QUERY_PARAMS) {
    const value = searchParams.get(name);
    if (value) metadata[name] = value.slice(0, MAX_VALUE_LENGTH);
  }
  return metadata;
}
